export default "__VITE_ASSET__CFKpmZHt__"